import React from 'react';
import {Trans} from 'react-i18next';
import AddSkincareTabSec from '../../components/tabsection/addSkincareTabSec';

export default function AddSkincare({numOfEnabled, numOfAvailable}) {
  return (
    <>
      <div className="portlet-title" style={{display: 'flex'}}>
        <h4>
          <Trans i18nKey="p.s.addskincare.theme">Product Management</Trans>
        </h4>
        <div style={{marginLeft: 'auto'}}>
          <Trans
            i18nKey="p.s.addskincare.theme.number.of.enabled"
            count={numOfEnabled}
          >
            {{numOfEnabled}} created
          </Trans>{' '}
          /{' '}
          {numOfAvailable === -1 ? (
            <Trans i18nKey="p.s.addskincare.theme.unlimited">Unlimited</Trans>
          ) : (
            <Trans
              i18nKey="p.s.addskincare.theme.number.of.available"
              count={numOfAvailable}
            >
              Total {{numOfAvailable}}
            </Trans>
          )}
        </div>
      </div>
      <div className="portlet-control">
        <AddSkincareTabSec />
      </div>
    </>
  );
}
